import { render, staticRenderFns } from "./listOrderB2b.vue?vue&type=template&id=3d8c348e&"
import script from "./listOrderB2b.vue?vue&type=script&lang=js&"
export * from "./listOrderB2b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports